export enum NavigationActionType { SECTION, TOS, MODE }
export enum NavigationDrawerMode { ROOT, COUNTRY, LANGUAGE }
